import svg from './row-svg/tri-alphabetique-v1.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function TriAlphabetiqueV1Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default TriAlphabetiqueV1Icon;
